/* Soccer page behaviours. No storage APIs. All motion respects reduced-motion. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    var cards=[].filter.call(root.querySelectorAll('.cgResult'),function(c){ if(c.dataset.kaReady) return false; c.dataset.kaReady='1'; return true; });
    if(cards.length && 'IntersectionObserver' in window && !reduce){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{rootMargin:'0px 0px -12% 0px'});
      cards.forEach(function(c){io.observe(c);});
    } else {
      cards.forEach(function(c){c.classList.add('is-in');});
    }
    var ke2=root.querySelector('#clubsKe2');
    if(ke2 && !reduce && !ke2.dataset.kaReady){
      ke2.dataset.kaReady='1';
      var section=ke2.closest('section'), ticking=false;
      var update=function(){
        ticking=false;
        var r=section.getBoundingClientRect(), vh=window.innerHeight;
        var t=Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height))); /* 0 entering -> 1 leaving */
        var rot=-14+t*22, ty=40-t*70;
        ke2.style.transform='rotate('+rot.toFixed(2)+'deg) translateY('+ty.toFixed(1)+'px)';
      };
      var onScroll=function(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } };
      var vis=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){ window.addEventListener('scroll',onScroll,{passive:true}); update(); }
          else { window.removeEventListener('scroll',onScroll); }
        });
      });
      vis.observe(section);
      section.addEventListener('ka:dispose',function(){ vis.disconnect(); window.removeEventListener('scroll',onScroll); });
    }
    root.querySelectorAll('[data-open]').forEach(function(a){
      if(a.dataset.kaReady) return;
      a.dataset.kaReady='1';
      a.addEventListener('click',function(ev){
        var el=document.getElementById(a.getAttribute('data-open'));
        if(!el) return;
        ev.preventDefault();
        el.open=true;
        el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  document.addEventListener('shopify:section:unload',function(e){ e.target.querySelectorAll('section').forEach(function(s){ s.dispatchEvent(new Event('ka:dispose')); }); });
})();
